import React from "react";
import { Search, Download, X, ChevronDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
  DropdownMenuCheckboxItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

const ESTADOS = ["Orçamento", "Pedido", "Adjudicado", "Realizado", "Recusado"];

export default function TableToolbar({
  search, setSearch, clientFilter, setClientFilter, clients,
  estadoFilter, setEstadoFilter, onClear, onExport, hasFilters,
}) {
  const selected = estadoFilter || [];
  const toggleEstado = (e) =>
    setEstadoFilter(selected.includes(e) ? selected.filter((x) => x !== e) : [...selected, e]);

  return (
    <div className="flex flex-col lg:flex-row lg:items-center gap-3">
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Pesquisar cliente, projeto, nº processo..."
          className="pl-9"
          data-testid="events-search-input"
        />
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <Select value={clientFilter || "all"} onValueChange={(v) => setClientFilter(v === "all" ? "" : v)}>
          <SelectTrigger className="w-[180px]" data-testid="events-filter-client-select">
            <SelectValue placeholder="Cliente" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos os clientes</SelectItem>
            {clients.map((c) => (
              <SelectItem key={c} value={c}>{c}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" className="w-[180px] justify-between font-normal" data-testid="events-filter-estado-select">
              <span className="truncate">
                {selected.length === 0 ? "Todos os estados"
                  : selected.length === 1 ? selected[0]
                  : `${selected.length} estados`}
              </span>
              <ChevronDown className="h-4 w-4 opacity-60 shrink-0" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-[200px]">
            <DropdownMenuLabel>Filtrar por estado</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {ESTADOS.map((e) => (
              <DropdownMenuCheckboxItem
                key={e}
                checked={selected.includes(e)}
                onCheckedChange={() => toggleEstado(e)}
                onSelect={(ev) => ev.preventDefault()}
                data-testid={`estado-filter-option-${e}`}>
                {e}
              </DropdownMenuCheckboxItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>

        {hasFilters && (
          <Button variant="ghost" size="sm" onClick={onClear} className="gap-1.5" data-testid="events-clear-filters-button">
            <X className="h-4 w-4" /> Limpar
          </Button>
        )}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="default" className="gap-2" data-testid="events-export-button">
              <Download className="h-4 w-4" /> Exportar
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => onExport("xlsx")} data-testid="events-export-excel-button">
              Exportar Excel (.xlsx)
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onExport("csv")} data-testid="events-export-csv-button">
              Exportar CSV (.csv)
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
